/* @flow */

import { combineReducers } from 'redux';
import { Map } from 'immutable';
import {
  FETCH_PAGES_SUCCESS,
  SAVE_PAGE_SUCCESS,
  UPDATE_PAGE_SUCCESS,
  CANCEL_PENDING,
} from 'catalog/actions/pages';
import {
  SERIALIZE_CONTENT,
  CREATE_CONTENT,
  CREATE_CONTENT_SUCCESS,
} from 'catalog/actions/contents';
import { getEditionPlatform, getDefaultPlatform } from './platforms';

const items = (state = Map(), action) => {
  switch (action.type) {
    case FETCH_PAGES_SUCCESS:
      return Map(action.response.entities.contents);
    case SAVE_PAGE_SUCCESS:
    case UPDATE_PAGE_SUCCESS:
      return state.merge(Map(action.response.entities.contents));
    case CREATE_CONTENT_SUCCESS:
      return state.set(action.content.id, action.content);
    default:
      return state;
  }
};

const pending = (state = Map(), action) => {
  switch (action.type) {
    case FETCH_PAGES_SUCCESS:
      return Map(action.response.entities.contents);
    case SAVE_PAGE_SUCCESS:
    case UPDATE_PAGE_SUCCESS:
      return state.merge(Map(action.response.entities.contents));
    case CREATE_CONTENT_SUCCESS:
    case SERIALIZE_CONTENT:
    case CANCEL_PENDING: {
      if (action.content) {
        return state.set(action.content.id, action.content);
      } else {
        return state;
      }
    }
    default:
      return state;
  }
};

const creating = (state = false, action) => {
  switch (action.type) {
    case CREATE_CONTENT:
      return true;
    case CREATE_CONTENT_SUCCESS:
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  items,
  pending,
  creating,
});

const getAllContents = state => state.contents.items;

export const getPageContents = (state, pageId) => {
  const contents = getAllContents(state);
  return contents
    .filter(c => c.pageId.toString() === pageId.toString())
    .toList();
};

export const getContent = (state, pageId, platform) => {
  const contents = getPageContents(state, pageId);
  const platformContent = contents.find(c => c.platform === platform.code);

  const fallbackToDefaultContent = () => {
    const defaultPlatform = getDefaultPlatform(state);
    return contents.find(c => c.platform === defaultPlatform.code);
  };

  // Fallback to default content if not found
  return platformContent || fallbackToDefaultContent();
};

export const getCurrentContent = (state, pageId) => {
  const platform = getEditionPlatform(state);
  return getContent(state, pageId, platform);
};

export const getPendingContents = (state, pageId) => {
  const pending = state.contents.pending;
  return pending
    .filter(c => c.pageId.toString() === pageId.toString())
    .toList();
};

export const getPendingContent = (state, pageId) => {
  const platform = getEditionPlatform(state);
  const pending = getPendingContents(state, pageId);

  return pending.find(c => c.platform === platform.code);
};

export const hasUpdate = (state, pageId) => {
  const pending = getPendingContents(state, pageId);
  const existing = getPageContents(state, pageId);

  return !pending.equals(existing);
};

export const getIsCreating = state => state.contents.creating;



// WEBPACK FOOTER //
// ./src/modules/catalog/reducers/contents.js